import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { ThemeProvider } from '@emotion/react';
import MuiMenu from '@mui/material/Menu';
import menuTheme from './Menu.theme.js';

/**
 * https://mui.com/api/menu/
 */
const Menu = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(ThemeProvider, Object.assign({ theme: menuTheme }, { children: jsx(MuiMenu, Object.assign({}, props, { children: children })) })));
};

export { Menu as default };
//# sourceMappingURL=Menu.js.map
